@use "variables" as *;

.card {
  position: relative;
  justify-content: flex-start !important;
  min-width: 164px;
  min-height: 230px;
  height: 100%;
  border-bottom-left-radius: 16px !important;
  border-bottom-right-radius: 16px !important;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    margin: $spacing-s;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.albumImage {
  width: 100%;
  height: 100%;
}

.image {
  width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.mainStack {
  width: 100%;
  flex-grow: 1;
}

.nameCard {
  height: 36px;
}

.name {
  padding: $spacing-s 0 $spacing-s $spacing-s;
  font-size: $fontSize-m;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loadingDescription {
  margin: $spacing-s;
  height: 20px !important;
  width: 20px !important;
}

.subtitle {
  display: flex;
  flex-direction: row;
  padding: 0 $spacing-s $spacing-s $spacing-s;
  font-size: $fontSize-xs;
  font-weight: normal;
  text-align: start;
  white-space: pre-wrap;
}

.artistName {
  font-weight: bold;
}

.username {
  font-size: $fontSize-xs;
  font-weight: lighter;
  padding: $spacing-s $spacing-s $spacing-s $spacing-xs;
  word-wrap: anywhere;
}

.avatar {
  width: 22px !important;
  height: 22px !important;
  margin: $spacing-xs;
}
